import { ReactNode, useState } from 'react';

import { createSafeContext } from '../../safe-context';

import type { createValidationRulesHandler } from './validation-rules';

type ValidationRulesLoader = ReturnType<typeof createValidationRulesHandler>['loader'];
type ValidationRulesData = Awaited<ReturnType<ValidationRulesLoader>>;
type ValidationRules = NonNullable<ValidationRulesData['addressValidationRules']>;

interface AddressValidationRulesContextValue {
  validationRules: ValidationRules;
  setValidationRules: (rules: ValidationRules) => void;
  isLoading: boolean;
}

const [useAddressValidationRules, Provider] = createSafeContext<AddressValidationRulesContextValue>();

interface AddressValidationRulesProviderProps {
  children: ReactNode;
  initialValidationRules: ValidationRules;
}

export function AddressValidationRulesProvider({
  children,
  initialValidationRules,
}: AddressValidationRulesProviderProps) {
  const [validationRules, setValidationRules] = useState(initialValidationRules);

  return (
    <Provider
      value={{ 
        validationRules,
        setValidationRules,
        isLoading: false 
      }}
    >
      {children}
    </Provider>
  );
}

export { useAddressValidationRules };